svg4everybody();

const APP = {

	name		   		: 'Alibra School',

	desktopXsWidth 		: 1199,

	tabletWidth    		: 991,

	tabletXsWidth  		: 767,

	mobileWidth    		: 599,

	websiteWrapper 		: $('#website-wrapper'),

	workArea       		: $('.js-workarea'),

	popupTrigger   		: $('.js-popup-trigger'),

	audioLink   		: $('.js-audio-link'),

	hiddenClass	   		: 'carousel--hidden',

	licenseesGallery 	: $('.js-licensees-gallery'),

	awardsGallery 	 	: $('.js-awards-gallery'),

	certificatesGallery : $('.js-certificates-gallery'),

	freeClassesGallery	: $('.js-free-classes-gallery'),

	defaultGallery		: $('.js-default-gallery'),

	noLoadedClass		: 'website-wrapper--no-load'

};
const selectStyler = () => {

    const select = $('.select select');

    if (select.length) {
        select.styler({
            selectSmartPositioning : false,
            selectSearch           : false,
            singleSelectzIndex     : '3'
        });

        $(document).on('click', '.select', function(){
            const dropdown = $(this).find('ul');
            if ( !dropdown.hasClass('ps') ) {
                const customScrollBar = new CustomScrollbar(dropdown);
            }
        });
    }

}
const headerWidth = () => {
    const header = $('.js-website-header');

    if ( header.length ) {
        header.css({
            'max-width' : window.deviceWidth
        });
        $('.top-navigation__dropdown').css({
            'max-width' : window.deviceWidth
        });
    }
}
const topNavigation = () => {

    const topNav            = $('.top-navigation');
    const element           = $('.js-nav-element');
    const elementActive     = element.find('.secondary-navigation__link._active');
    const primaryLink       = $('.js-top-nav-element');
    const secondaryLink     = $('.js-sec-nev-element');
    const activeClass       = 'top-navigation__level--active';
    const dropdownLink      = $('.js-dropdown-link');
    const activeTabsClass   = '_active';
    var timer;

    //move marker to active link
    if ( elementActive.length ) {
        animateMarker(elementActive.parents('.js-nav-element'));
    }
    primaryLink.on('mouseenter mouseleave', function(e){
        const _this = $(this);

        if ( e.type === 'mouseenter' ) {
            if (!!timer) {
                clearTimeout(timer);
            }
        }
        else if ( e.type === 'mouseleave' ) {
            let id = $(this).attr('data-top-element');

            if ( !$('[data-sec-element="'+ id +'"]').find('.secondary-navigation__link._active').length ) {
                const el = $('.secondary-navigation__link._active');

                if ( el.length ) {
                    const parent = el.parents('.js-nav-element');
                    const _id    = parent.attr('data-sec-element');

                    timer = setTimeout(function(){
                        animateMarker(parent);
                        //$(this).removeClass(activeClass);
                        _this.removeClass(activeClass);
                        $('[data-top-element='+_id+']').addClass(activeClass);
                    }, 200);
                }
            }
        }
    });
    element.on('mouseenter mouseleave', function(e){
        const id = $(this).attr('data-sec-element');

        if ( e.type === 'mouseenter' ) {

            if (!!timer) {
                clearTimeout(timer);
            }

            animateMarker($(this));
            primaryLink.removeClass(activeClass);
            $('[data-top-element='+id+']').addClass(activeClass);
        }
        else if ( e.type === 'mouseleave' ) {
            if ( !$(this).find('.secondary-navigation__link._active').length ) {
                const el = $('.secondary-navigation__link._active');

                if ( el.length ) {
                    const parent = el.parents('.js-nav-element');
                    const _id    = parent.attr('data-sec-element');

                    timer = setTimeout(function(){
                        animateMarker(parent);
                        primaryLink.removeClass(activeClass);
                        $('[data-top-element='+_id+']').addClass(activeClass);
                    }, 200);
                }
            }
            else {}
        }
    });

    //change tabs :: 3rd level
    dropdownLink.on('click', function(){
        let parent  = $(this).parents('.js-dropdown');
        let id      = $(this).attr('data-tabs-link');


        if ( !$(this).hasClass(activeTabsClass) ) {
            parent.find('.js-dropdown-link').removeClass(activeTabsClass);
            $(this).addClass(activeTabsClass);
            parent.find('.js-dropdown-inside').removeClass(activeTabsClass);
            parent.find('[data-tabs-id='+id+']').addClass(activeTabsClass);
        }
    });

}

const animateMarker = (el) => {
    const navigation = $('.js-secondary-navigation');
    const marker     = $('.js-nav-marker');
    const width      = el.width();
    const left       = el.offset().left - navigation.offset().left;

    marker.css({
        'left'  : left,
        'width' : width
    });
}
const headerCollapse = () => {

    const header             = $('.js-website-header');
    const collapseClass      = 'website-header--collapsed';
    const expandedClass      = 'website-header--expanded';
    const expandedHeight     = 350;
    let headerCollapseHeight = header.height() * 2;

    APP.websiteWrapper.on('scroll', function(){
        //collapse header
        if(APP.websiteWrapper.scrollTop() > headerCollapseHeight){
            header.addClass(collapseClass);
        }
        else {
            header.removeClass(collapseClass);
        }
        //expand header with no bottom bar
        if ( $('.js-hero-slider').length ) {
            if(APP.websiteWrapper.scrollTop() > window.heroHeight){
                header.addClass(expandedClass);
            }
            else {
                header.removeClass(expandedClass);
            }
        }
        if ( $('.js-header-bar-to-show-element').length ) {
            if(APP.websiteWrapper.scrollTop() > window.headerBarToShowHeight){
                header.addClass(expandedClass);
            }
            else {
                header.removeClass(expandedClass);
            }
        }
    });
}
const popup = (id) => {

    const popup     = $(id.attr('href'));
    const close     = $('.js-close-popup');

    const player    = $('#audio-player');
    const track     = player.find('.js-media-controller-title');
    const download  = player.find('.js-media-controller-download');
    const control   = player.find('.js-media-controller');

    if ( popup.length ) {
        id.magnificPopup({
            type            :'inline',
            removalDelay    : 200,
            midClick        : true,
            callbacks       : {
                beforeOpen  : function() {
                    this.st.mainClass = this.st.el.attr('data-effect');
                    const id = this.st.el.attr('href');

                    if (typeof this.st.el.attr('data-url') !== 'undefined') {
                        const title = this.st.el.attr('data-title');
                        const url   = this.st.el.attr('data-url');

                        player.find('source').attr('src', url);
                        document.getElementById('audio-popup').load();

                        track.text(title);
                        download.attr('href', url);

                        audioDurationHandler();

                        function audioDurationHandler() {
                            let duration    = 0;
                            const audio     = document.getElementById('audio-popup');
                            const timer     = control.find('.media-controller__timer');

                            audio.addEventListener('loadedmetadata', function () {
                                if ( audio.readyState > 0 ) {
                                    const minutes  = parseInt(audio.duration / 60, 10);
                                    const seconds  = parseInt(audio.duration % 60);
                                    duration = minutes+":"+seconds;

                                    timer.text(duration);
                                }
                            });
                        }
                    }
                    if (typeof this.st.el.attr('data-comparison') !== 'undefined') {
                        setTimeout(function(){
                            comparisonTable(id);
                        }, 210);
                    }
                },
                open        : function () {},
                close       : function () {
                    if (typeof this.st.el.attr('data-url') !== 'undefined') {
                        document.getElementById('audio-popup').pause();
                        player.find('source').attr('src', '');

                        if ( control.hasClass('_playing') ) {
                            control.removeClass('_playing').addClass('_paused');
                        }
                    }
                }
            }
        });

        close.on('click', function(){
            $.magnificPopup.proto.close.call(this);
        });
    }
}

const mobileNavigation = (width) => {

    const button                = $('.js-mobile-nav-button');
    const sidebar               = $('.js-mobile-sidebar');
    const activeClass           = '_nav-opened';

    const navigation            = $('.js-mobile-navigation');
    const navigationLevel       = $('.js-mobile-navigation-level');
    const navigationLink        = $('.js-mobile-navigation-link');
    const navigationLinkBack    = $('.js-mobile-navigation-link-back');
    const navigationLinkBackVal = $('.js-mobile-navigation-link-back-value');
    const navigationActiveClass = '_active';
    const linkBackActiveClass   = '_link-back-visible';
    let right                   = 0;

    button.on('click', function(){
        if ( !APP.websiteWrapper.hasClass(activeClass) ) {
            APP.websiteWrapper.addClass(activeClass);
        }
        else {
            right = 0;
            navigation.css('right', right * 100 + '%');
            sidebar.removeClass(linkBackActiveClass);
            navigationLevel.removeClass(navigationActiveClass);
            navigationLinkBackVal.val('');
            APP.websiteWrapper.removeClass(activeClass);
        }
    });

    //go to sublevel
    navigationLink.on('click', function(e) {
        e.preventDefault();
        if ( $(this).parents('.js-mobile-navigation-element').children().length >= 2 ) {
            right++;
            $(this).parents('.js-mobile-navigation-element').children('.js-mobile-navigation-level').addClass(navigationActiveClass);
            navigation.css('right', right * 100 + '%');
        }

        //show link back and change it's title
        const levelTitle     = $(this).attr('data-level-title');
        sidebar.addClass(linkBackActiveClass);
        navigationLinkBackVal.text(levelTitle);
    });

    //go back to previous level
    navigationLinkBack.on('click', function(e) {
        e.preventDefault();
        right--;
        navigation.css('right', right * 100 + '%');
        $('.js-mobile-navigation-level.'+navigationActiveClass).last().removeClass(navigationActiveClass);

        const level      = $('.js-mobile-navigation-level.'+navigationActiveClass);
        const levelTitle = level.last().parent('.js-mobile-navigation-element').find('.mobile-navigation__link-value').eq(0).text();
        navigationLinkBackVal.text(levelTitle);

        if (right < 1) {
            sidebar.removeClass(linkBackActiveClass);
        }
    });

    $(document).on('mouseup touchend', function(e){
        if (!sidebar.is(e.target) && sidebar.has(e.target).length === 0 && !button.is(e.target) && button.has(e.target).length === 0 ) {
            right = 0;
            navigation.css('right', right * 100 + '%');
            sidebar.removeClass(linkBackActiveClass);
            navigationLevel.removeClass(navigationActiveClass);
            navigationLinkBackVal.val('');
            APP.websiteWrapper.removeClass(activeClass);
        }
    });
    $(window).on('load resize', function(){
        if ( window.deviceWidth > width ) {
            APP.websiteWrapper.removeClass(activeClass);
        }
    });
}
const contactsWidget = () => {

    const widget            = $('.js-widget');
    const button            = $('.js-widget-trigger');
    const activeClass       = '_contacts-widget-shown';
    const buttonActiveClass = '_active';

    button.on('click', function(){
        if ( !APP.websiteWrapper.hasClass(activeClass) ) {
            setWidth();
            APP.websiteWrapper.addClass(activeClass);
            $(this).addClass(buttonActiveClass);
        }
        else {
            unsetWidth();
            APP.websiteWrapper.removeClass(activeClass);
            $(this).removeClass(buttonActiveClass);
        }
    });

    $(document).on("mouseup touchend", function(e){
        if (!widget.is(e.target) && widget.has(e.target).length === 0) {
            unsetWidth();
            APP.websiteWrapper.removeClass(activeClass);
            button.removeClass(buttonActiveClass);
        }
    });

}
const heroSlider = (width) => {

    const slider = $('.js-hero-slider');

    if ( slider.length ) {
        const hiddenClass  = 'hero--hidden';
        const element      = $('.js-hero-element');

        slider.on('init', function(event, slick){
            slider.removeClass(hiddenClass);
            window.heroHeight = slider.height() + 35;
        });
        slider.on('init beforeChange afterChange', function(event, slick, currentSlide){
            const prevArrow = $('.js-hero-arrow-prev');
            const nextArrow = $('.js-hero-arrow-next');

            let current = $(slick.$slides.get(currentSlide));

            let prevText = current.attr('data-hero-prev-button');
            let nextText = current.attr('data-hero-next-button');

            prevArrow.html(prevText);
            nextArrow.html(nextText);

        });

        slider.slick({
            slide           : '.hero__element',
            rows            : 0,
            slidesToShow    : 1,
            infinite        : true,
            arrows          : true,
            dots            : true,
            pauseOnHover    : false,
            autoplay        : true,
            autoplaySpeed   : 10000,
            prevArrow       : '<button type="button" class="slick-prev"><span class="slick-arrow__icon"><svg class="i"><use xlink:href="#arrow-left"/></svg></span><span class="slick-arrow__text"><span class="value js-hero-arrow-prev"></span></span></button>',
            nextArrow       : '<button type="button" class="slick-next"><span class="slick-arrow__text "><span class="value js-hero-arrow-next"></span></span><span class="slick-arrow__icon"><svg class="i"><use xlink:href="#arrow-right"/></svg></span></button>',
            appendArrows    : $('.js-hero-arrows', slider),
            appendDots      : $('.js-hero-dots', slider),
            responsive      : [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: false
                    }
                }
            ],
            customPaging:function (a, b) {
                return '<div class="wrapper" data-anim="base wrapper"><div class="circle" data-anim="base left"></div><div class="circle" data-anim="base right"></div></div>'
            }
        });

        //this positioning is no longer used
        $(window).on('load resize', function(){
            element.each(function(){
                let position = $(this).attr('data-hero-image-position');

                if ( window.deviceWidth <= width ) {
                    $(this).find('.js-hero-element-image').css('right', '');
                }
                else {
                    $(this).find('.js-hero-element-image').css('right', position);
                }
            })
        });

    }
}
const coursesCarousel = () => {

    const slider = $('.js-courses-carousel');

    if ( slider.length ) {
        slider.slick({
            slidesToShow    : 3,
            variableWidth   : true,
            rows            : 0,
            infinite        : false,
            arrows          : true,
            dots            : false,
            prevArrow       : '<button type="button" class="slick-prev"><svg class="i"><use xlink:href="#stroke-arrow-left"/></svg></button>',
            nextArrow       : '<button type="button" class="slick-next"><svg class="i"><use xlink:href="#stroke-arrow-right"/></svg></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });

    }
}
//Пример в яндекс песочнице
//https://tech.yandex.ru/maps/jsbox/2.1/balloon_autopan

const schoolsMap = (id, lat, lon, file) => {
    if ( $('#'+id).length ) {

        const mapElement    = $('.js-map-element');
        const activeClass   = 'map-element--active';
        const markerDefault = 'assets/images/svg_icons/map-marker.svg';
        const markerActive  = 'assets/images/svg_icons/map-marker-active.svg';
        const pcCenter      = $('#'+id).attr('data-pc-center').split(',');
        const mobileCenter  = $('#'+id).attr('data-mobile-center').split(',');

        let mapCenter = pcCenter;

        if ($(window).width() <= APP.tabletXsWidth ) {
            mapCenter = mobileCenter;
        }

        mapElementsHandler(1);
        ymaps.ready(function () {
            let map = new ymaps.Map(id, {
                    center: mapCenter,
                    zoom: 11,
                    controls: []
                }),
                balloonLayout = ymaps.templateLayoutFactory.createClass(
                    '<div class="map-popup">' +
                        '<button type="button" class="map-popup__close js-close-popup"><svg class="i"><use xlink:href="#close-modal"/></svg></button>' +
                            '<div class="map-popup__arrow"></div>' +
                            '<div class="map-popup__inside">' +
                            '$[[options.contentLayout observeSize]]' +
                        '</div">' +
                    '</div>', {
                        /**
                         * Строит экземпляр макета на основе шаблона и добавляет его в родительский HTML-элемент.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#build
                         * @function
                         * @name build
                         */
                        build: function () {
                            this.constructor.superclass.build.call(this);
                            this._$element = $('.map-popup', this.getParentElement());
                            this.applyElementOffset();
                            this._$element.find('.js-close-popup')
                                .on('click', $.proxy(this.onCloseClick, this));
                        },

                        /**
                         * Удаляет содержимое макета из DOM.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#clear
                         * @function
                         * @name clear
                         */
                        clear: function () {
                            this._$element.find('.js-close-popup')
                                .off('click');

                            this.constructor.superclass.clear.call(this);
                        },
                        /**
                         * Метод будет вызван системой шаблонов АПИ при изменении размеров вложенного макета.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                         * @function
                         * @name onSublayoutSizeChange
                         */
                        onSublayoutSizeChange: function () {
                            balloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

                            if(!this._isElement(this._$element)) {
                                return;
                            }

                            this.applyElementOffset();

                            this.events.fire('shapechange');
                        },

                        /**
                         * Сдвигаем балун, чтобы "хвостик" указывал на точку привязки.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                         * @function
                         * @name applyElementOffset
                         */
                        applyElementOffset: function () {

                            this._$element.css({
                                top: -(this._$element[0].offsetHeight/2 + 19)
                            });
                        },

                        /**
                         * Закрывает балун при клике на крестик, кидая событие "userclose" на макете.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                         * @function
                         * @name onCloseClick
                         */
                        onCloseClick: function (e) {
                            e.preventDefault();

                            this.events.fire('userclose');
                        },

                        /**
                         * Используется для автопозиционирования (balloonAutoPan).
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/ILayout.xml#getClientBounds
                         * @function
                         * @name getClientBounds
                         * @returns {Number[][]} Координаты левого верхнего и правого нижнего углов шаблона относительно точки привязки.
                         */
                        getShape: function () {
                            if(!this._isElement(this._$element)) {
                                return balloonLayout.superclass.getShape.call(this);
                            }

                            var position = this._$element.position();

                            return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                                [position.left, position.top], [
                                    position.left + this._$element[0].offsetWidth,
                                    position.top + this._$element[0].offsetHeight + this._$element.find('.map-popup__arrow')[0].offsetHeight
                                ]
                            ]));
                        },

                        /**
                         * Проверяем наличие элемента (в ИЕ и Опере его еще может не быть).
                         * @function
                         * @private
                         * @name _isElement
                         * @param {jQuery} [element] Элемент.
                         * @returns {Boolean} Флаг наличия.
                         */
                        _isElement: function (element) {
                            return element && element[0] && element.find('.map-popup__arrow')[0];
                        }
                    }),

                // Создание вложенного макета содержимого балуна.
                balloonLayoutContent = ymaps.templateLayoutFactory.createClass(
                    '<h5 class="map-popup__heading">$[properties.balloonHeader]</h5>' +
                    '<p class="map-popup__text">$[properties.balloonMetro]</p>' +
                    '<p class="map-popup__text">$[properties.balloonAddress]</p>' +
                    '<p class="map-popup__text"><a href="tel:$[properties.balloonPhone]">$[properties.balloonPhone]</a></p>' +
                    '<p class="map-popup__text"><a href="mailto:$[properties.balloonEmail]">$[properties.balloonEmail]</a></p>' +
                    '<div class="map-popup__control"><a class="button button--bordered-grey" target="_blank" href="https://$[properties.balloonButton]">Перейти к отделению</a></div>'
                );

            let zoomControls = ymaps.templateLayoutFactory.createClass(
                "", {
                        build: function () {
                            zoomControls.superclass.build.call(this);
                            this.zoomInCallback = ymaps.util.bind(this.zoomIn, this);
                            this.zoomOutCallback = ymaps.util.bind(this.zoomOut, this);
                            $('#zoom-in').bind('click', this.zoomInCallback);
                            $('#zoom-out').bind('click', this.zoomOutCallback);
                            $('#geo').bind('click', this.geo);
                        },
                        clear: function () {
                            $('#zoom-in').unbind('click', this.zoomInCallback);
                            $('#zoom-out').unbind('click', this.zoomOutCallback);
                            zoomControls.superclass.clear.call(this);
                        },
                        zoomIn: function () {
                            var map = this.getData().control.getMap();
                            map.setZoom(map.getZoom() + 1, {checkZoomRange: true});
                        },
                        zoomOut: function () {
                            var map = this.getData().control.getMap();
                            map.setZoom(map.getZoom() - 1, {checkZoomRange: true});
                        },
                        geo: function() {
                            ymaps.geolocation
                                .get({
                                    provider           : 'yandex',
                                    mapStateAutoApply  : true,
                                    autoReverseGeocode : false
                                })
                                .then(function (result) {
                                    map.geoObjects.add(result.geoObjects);
                                });
                        }
                    }),
                zoomControl = new ymaps.control.ZoomControl({options: {layout: zoomControls}});
                map.controls.add(zoomControl, {position: {right: '20px', top: '0', height: '100%'}});


            map.behaviors.disable('scrollZoom');

            $.ajax({
                url: file
            }).done(function(data) {
                $.each(data['elements'], function(i, element){
                    // Создание метки с пользовательским макетом балуна.
                    const placemark = new ymaps.Placemark(element.coordinates, {},{
                        hideIconOnBalloonOpen: false,
                        iconLayout: 'default#image',
                        iconImageHref: markerDefault,
                        iconImageSize: [31, 45],
                        iconImageOffset: [-15, -40]
                    });

                    /*objectManager.objects.options.set('preset', 'islands#grayIcon');
                    objectManager.add({
                        type: 'Feature',
                        id: i,
                        geometry: {
                            type: 'Point',
                            coordinates: element.coordinates
                        },
                        properties: {}
                    });*/

                    map.geoObjects.add(placemark);

                    placemark.events.add('click', function(e) {
                        mapElement.removeClass(activeClass);
                        $('#js-map-element-'+i).addClass(activeClass);

                        mapElementScrollHandler(i);
                        changeMapLocation(map, element.coordinates);
                    });

                    //toggle element
                    //removed on the 22.10.19
                    /*$('#js-map-element-'+i).on('click', function(){
                        mapElement.removeClass(activeClass);

                        if ( !$(this).hasClass(activeClass) ) {
                            $(this).addClass(activeClass);

                            changeMapLocation(map, element.coordinates);
                        }
                    });*/
                });
            });

            //change city
            const mapSelect = $('.js-map-select');
            mapSelect.on('change', function(){
                const val = $(this).val();

                if ( !val || val == 0 ) return false;

                const option  = $(this).find('[value="'+ val +'"]');
                const lat     = parseFloat(option.attr('data-lat'));
                const lon     = parseFloat(option.attr('data-lon'));
                const cityID  = parseFloat(option.attr('data-id'));

                changeMapLocation(map, [lat, lon]);
                mapElementsHandler(cityID);
            });
        });
    }
}
const changeMapLocation = (map, coords) => {
    map.panTo(coords, {
        flying: 1
    });
}
const mapElementsHandler = (id) => {
    const element   = $('.js-map-element');

    element.hide();
    $('[data-map-element="'+ id +'"]').fadeIn(100);
    window.scrollbars.update();
}
const mapElementScrollHandler = (id) => {
    const element = $('#js-map-element-'+id);

    if ( element.length ) {
        const container = element.parents('.js-scrollable-block');
        const containerTop = container.scrollTop();
        const position  = element.position().top;

        container.animate({scrollTop: position + containerTop}, 500);
    }
}
function setWidth() {
    APP.websiteWrapper.css({
        'max-width' : window.deviceWidth + 'px'
    });
}
function unsetWidth() {
    APP.websiteWrapper.removeAttr('style');
}

const animation = () => {
    $('.animate_afc, .animate_afc-light, .animate_afl, .animate_afr, .animate_aft, .animate_afb, .animate_wfc, .animate_hfc, .animate_rfc, .animate_rfl, .animate_rfr').waypoint({
        handler: function() {
            let el = $(this.element);

            if ( !el.hasClass('animate_start') ) {
                el.addClass('animate_start');
            }
        },
        offset: '105%',
        context: document.getElementById('website-wrapper')
    });
}
function responsiveTabs(id, type) {

    const tabs = id;

    if ( tabs.length ) {
        tabs.easyResponsiveTabs({
            type                            : type,
            tabidentify                     : '_responsive-tabs',
            activetab_bg                    : 'transparent',
            inactive_bg                     : 'transparent',
            active_border_color             : 'transparent',
            active_content_border_color     : 'transparent'
        });
    }
}
function routeMap(container, lat, lon) {
    if ( $('#'+container).length ) {
        ymaps.ready(function () {
            var map = new ymaps.Map(container, {
                    center: [lat, lon],
                    zoom: 13,
                    controls: []
                }),
                placemark = new ymaps.Placemark(map.getCenter(), {
                    hintContent: 'Москва, ул. Профсоюзная, д. 64, корп. 2',
                    balloonContent: 'Москва, ул. Профсоюзная, д. 64, корп. 2'
                }, {
                    iconLayout: 'default#image',
                    iconImageHref: 'assets/images/svg_icons/map-marker.svg',
                    iconImageSize: [31, 45],
                    iconImageOffset: [-15, -40]
                });

            map.geoObjects.add(placemark);
        });
    }
}
const freeClassesSlider = () => {

    const slider = $('.js-free-classes-slider');

    if ( slider.length ) {
        slider.slick({
            slidesToShow    : 3,
            variableWidth   : true,
            rows            : 0,
            infinite        : false,
            arrows          : true,
            dots            : false,
            prevArrow       : '<button type="button" class="slick-prev"><svg class="i"><use xlink:href="#stroke-arrow-left"/></svg></button>',
            nextArrow       : '<button type="button" class="slick-next"><svg class="i"><use xlink:href="#stroke-arrow-right"/></svg></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });

    }
}
const teamCarousel = (width) => {

    const slider = $('.js-team-carousel');

    if ( slider.length ) {
        const hiddenClass    = 'team-carousel--hidden';
        const slidesToScroll = Math.ceil($('.js-team-carousel .team-carousel__element').not('.slick-cloned').length/3);
        slider.on('init', function(event, slick){
            slider.removeClass(hiddenClass);
        });

        $(window).on('load resize', function(){
            if ( window.deviceWidth >= width ) {
                //slider.slick('reinit');
            }
        });

        slider.slick({
            slidesToShow    : 5,
            slidesToScroll  : slidesToScroll,
            variableWidth   : true,
            rows            : 0,
            infinite        : false,
            arrows          : true,
            dots            : true,
            prevArrow       : '<button type="button" class="slick-prev"><svg class="i"><use xlink:href="#stroke-arrow-left"/></svg></button>',
            nextArrow       : '<button type="button" class="slick-next"><svg class="i"><use xlink:href="#stroke-arrow-right"/></svg></button>',
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow    : 2,
                        slidesToScroll  : 2
                    }
                },
                {
                    breakpoint: 599,
                    settings: {
                        slidesToShow    : 2,
                        variableWidth   : false,
                        rows            : 2
                    }
                }
            ]
        });

    }
}
const reviewsCarousel = () => {

    const slider = $('.js-reviews-carousel');

    if ( slider.length ) {
        const hiddenClass  = 'reviews-carousel--hidden';
        slider.on('init', function(event, slick){
            slider.removeClass(hiddenClass);
        });

        slider.slick({
            slidesToShow    : 2,
            variableWidth   : true,
            rows            : 0,
            infinite        : false,
            arrows          : true,
            dots            : false,
            prevArrow       : '<button type="button" class="slick-prev"><svg class="i"><use xlink:href="#stroke-arrow-left"/></svg></button>',
            nextArrow       : '<button type="button" class="slick-next"><svg class="i"><use xlink:href="#stroke-arrow-right"/></svg></button>',
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 1
                    }
                },
                {
                    breakpoint: 599,
                    settings: {
                        slidesToShow: 1,
                        variableWidth: false
                    }
                }
            ]
        });

    }
}
function scroll2(width) {
    const link               = $('.js-scroll-link');
    const linkAlt            = $('.js-scroll-link-alt');
    let scrollToOffsetTop    = -120;
    let scrollToOffsetTopAlt = -97;

    link.on('click', function(e){
        e.preventDefault();
        APP.websiteWrapper.scrollTo(this.hash, this.hash, {
            offset: scrollToOffsetTop
        });
    });

    linkAlt.on('click', function(e){
        e.preventDefault();
        APP.websiteWrapper.scrollTo(this.hash, this.hash, {
            offset: scrollToOffsetTopAlt
        });
    });

    $(window).on('load resize', function(){
        if ( window.deviceWidth <= width ) {
            scrollToOffsetTop    = -90;
            scrollToOffsetTopAlt = -90;
        }
        else {
            scrollToOffsetTop    = -120;
            scrollToOffsetTopAlt = -97;
        }
    });

}
const reviewsElement = () => {

    const link        = $('.js-reviews-element-link');
    const activeClass = '_active';

    link.on('click', function(){
        const parent        = $(this).parents('.js-reviews-element');
        const preview       = parent.find('.js-reviews-element-preview');
        const text          = parent.find('.js-reviews-element-text');
        const textHeight    = text.height();
        const previewHeight = preview.attr('data-height');

        if ( !previewHeight ) {
            preview.attr('data-height', preview.height())
        }

        const expanded      = $(this).attr('data-expanded-text');
        const collapsed     = $(this).attr('data-collapsed-text');

        if ( !parent.hasClass(activeClass) ) {
            parent.addClass(activeClass);
            preview.animate({
                maxHeight: textHeight + 'px'
            }, 300);
            $(this).text(expanded);
        }
        else {
            parent.removeClass(activeClass);
            preview.animate({
                maxHeight: preview.attr('data-height') + 'px'
            }, 300);
            $(this).text(collapsed);
        }

    });
}
const blogCarousel = () => {

    const slider = $('.js-blog-carousel');

    if ( slider.length ) {
        const hiddenClass  = 'blog-carousel--hidden';
        slider.on('init', function(event, slick){
            slider.removeClass(hiddenClass);
        });

        slider.slick({
            slidesToShow    : 3,
            variableWidth   : true,
            rows            : 0,
            infinite        : false,
            arrows          : true,
            dots            : true,
            prevArrow       : '<button type="button" class="slick-prev"><svg class="i"><use xlink:href="#stroke-arrow-left"/></svg></button>',
            nextArrow       : '<button type="button" class="slick-next"><svg class="i"><use xlink:href="#stroke-arrow-right"/></svg></button>',
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow    : 2
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow    : 1
                    }
                },
                {
                    breakpoint: 599,
                    settings: {
                        slidesToShow    : 1,
                        variableWidth   : false,
                        centerMode      : true,
                        centerPadding   : '15px'
                    }
                }
            ]
        });

    }
}
function inputTel(id) {

    if ( id.length ) {
        id.mask("+7 (999) 999-99-99", {autoclear: false});
    }
}
const defaultValidator = () => {

    const form = $('.js-default-form-validation');

    if ( form.length ) {
        $.validator.setDefaults({
            debug: true,
            success: 'valid'
        });
        $.validator.addMethod("validate_email", function(value, element) {
            if (/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/.test(value)) {
                return true;
            } else {
                return false;
            }
        });
        $.validator.addMethod("minlenght_phone", function (value, element) {
            return value.replace(/\D+/g, '').length > 10;
        });
        $.validator.addMethod("required_phone", function (value, element) {
            return value.replace(/\D+/g, '').length > 1;
        });

        form.validate({
            errorClass   : "input--error",
            validClass   : "input--success",
            errorElement : "span",
            rules : {
                formEmail: {
                    required: true,
                    email   : true,
                    validate_email: true
                },
                formPhone: {
                    required        : true,
                    required_phone  : true,
                    minlenght_phone : true
                },
                formAgreement: {
                    required: true
                }
            },
            highlight: function(element, errorClass, validClass) {
                $(element).parents('.js-input').addClass(errorClass).removeClass(validClass);
            },
            unhighlight: function(element, errorClass, validClass) {
                $(element).parents('.js-input').removeClass(errorClass).addClass(validClass);
            },
            onfocusout: function (element) {
                if (!this.checkable(element) && (element.name in this.submitted || !this.optional(element)))
                {
                    var currentObj = this;
                    var currentElement = element;
                    var delay = function () { currentObj.element(currentElement); };
                    setTimeout(delay, 0);
                }
            },
            errorPlacement: function(error, element) {
                error.appendTo($(element).parents('.js-input'));
            },
            submitHandler: function() {}
        });
    }
}
const appFormValidator = (id) => {
    if ( id.length ) {
        $.validator.setDefaults({
            debug: true,
            success: 'valid'
        });
        $.validator.addMethod("validate_email", function(value, element) {
            if (/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/.test(value)) {
                return true;
            } else {
                return false;
            }
        });
        $.validator.addMethod("minlenght_phone", function (value, element) {
            return value.replace(/\D+/g, '').length > 10;
        });
        $.validator.addMethod("required_phone", function (value, element) {
            return value.replace(/\D+/g, '').length > 1;
        });

        id.validate({
            errorClass: "input--error",
            validClass: "input--success",
            rules : {
                appFormEmail: {
                    required: true,
                    email: true,
                    validate_email: true
                },
                appFormTel: {
                    required: true,
                    validate_phone: true
                }
            },
            highlight: function(element, errorClass, validClass) {
                $(element).parents('.js-input').addClass(errorClass).removeClass(validClass);
            },
            unhighlight: function(element, errorClass, validClass) {
                $(element).parents('.js-input').removeClass(errorClass).addClass(validClass);
            },
            onfocusout: function(element) {
                if (!this.checkable(element) && (element.name in this.submitted || !this.optional(element))) {
                    this.element(element);
                }
            },
            submitHandler: function() {}
        });
    }
}
function CustomScrollbar(cont){
  this.cont = cont;
  this.scrollBars = [];
  this.init();
}

CustomScrollbar.prototype = {
  init: function(){
    var obj = this;

    if (this.cont.length > 0) {
      this.cont.each(function(){
        obj.scrollBars.push(new PerfectScrollbar(this));
      })
    }
  },
  update: function(){
    this.scrollBars.forEach(function(el){
      el.update();
    })
  }
}
const mapView = (width) => {

    const list       = $('.js-map-list-view');
    const map        = $('.js-map-view');
    const mapButton  = $('.js-control-map');
    const listButton = $('.js-control-list');
    let noHide       = true;

    mapButton.on('change', function(){
        if ( $(this).prop('checked' )) {
            list.fadeOut(200);
            map.fadeIn(200);
        }
    });
    listButton.on('change', function(){
        if ( $(this).prop('checked') ) {
            map.fadeOut(200);
            list.fadeIn(200);
        }
    });


    $(window).on('load resize', function(){
        if ( window.deviceWidth <= width ) {
            if ( noHide ) {
                noHide = false;
                list.hide();
            }
        }
        else {
            noHide = true;
            list.removeAttr('style');
            map.removeAttr('style');
        }
    });

}
const videoPopup = () => {

    const videoLink     = $('.js-video-link');

    if ( videoLink.length ) {
        videoLink.magnificPopup({
            type: 'inline',
            closeMarkup: '<button title="%title%" type="button" class="mfp-close popup__close"><svg class="i"><use xlink:href="#close-modal-white"/></svg></button>',
            tClose: 'Закрыть (Esc)',
            midClick: true,
            removalDelay: 200,
            callbacks: {
                beforeOpen: function beforeOpen() {
                    this.st.mainClass = this.st.el.attr('data-effect');
                    $('body').addClass(this.st.el.attr('data-overlay'));
                    $("#video-player").on("contextmenu", function() {
                        return false;
                    });
                },
                open: function () {
                    $('#video-player').find('source').attr('src', this.st.el.attr('data-url'));
                    document.getElementById('video-popup').load();
                },
                close: function close() {
                    $('#video-popup').trigger('pause');
                    $('body').removeClass(this.st.el.attr('data-overlay'));
                }
            }
        });

    }

}
const mediaController = () => {

    mediaDurationHandler();
    $(document).on('click', '.js-media-button-play', function(){

        const parent      = $(this).parents('.js-media-controller');
        const playerID    = parent.find('audio').attr('id');
        const player      = document.getElementById(playerID);
        const play        = parent.find('.js-media-button-play');
        const pause       = parent.find('.js-media-button-pause');
        const slider      = parent.find('#js-media-slider');
        const progressBar = parent.find('#js-media-progress');
        const time        = parent.find('#js-current-time');
        const mediaBlock  = parent.find('.js-media-control');
        const volumeBlock = parent.find('.js-media-controller-sound');
        const volumeON    = parent.find('.js-media-controller-sound-on');
        const volumeOFF   = parent.find('.js-media-controller-sound-off');
        const volumeBar   = parent.find('.js-media-controller-sound-level');
        const soundON     = 'media-controller__sound--enabled';
        const soundOFF    = 'media-controller__sound--disabled';
        const playClass   = '_playing';
        const pauseClass  = '_paused';
        const loadedClass = '_loaded';
        let duration      = 0;
        let volume        = 1;


        if ( !parent.hasClass(loadedClass) ) {

            parent.addClass(loadedClass);

            player.onloadedmetadata = function() {
                duration = player.duration;
                progressBar.progressbar('option', { 'max' : duration });
            };

            player.load();

            player.volume = 1;
            player.addEventListener('timeupdate', function() {
                progressBar.progressbar('value', player.currentTime);
                time.text(getTime(player.currentTime));
            }, false);

            volumeBar.progressbar({
                value: player.volume * 100
            });

            volumeBar.on('click', function(e) {
                let info = getProgressBarClickInfo($(this), e);

                volumeBar.progressbar('value', info.value);
                player.volume = info.value / info.max;
            });

            progressBar.progressbar({
                value: player.currentTime
            });

            progressBar.on('progressbarchange', function() {
                let position = parseInt($(this).find('.ui-progressbar-value').css('width')),
                    width    = $(this)[0].clientWidth - 8;

                if (position >= width) {
                    position = width;
                }

                slider.css({
                    'left': position
                });
            });

            progressBar.on('click', function(e) {
                let info = getProgressBarClickInfo($(this), e);

                player.currentTime = player.duration / info.max * info.value;
            });

            pause.on('click', function() {
                player[player.paused ? 'play' : 'pause']();
                mediaBlock.removeClass(playClass).addClass(pauseClass);
            });
            
            volumeOFF.on('click', function() {
                if (player.volume === 0) {
                    player.volume = volume;
                }
                else {
                    volume = player.volume;
                    player.volume = 0;
                }


                volumeBar.progressbar('value', player.volume * 100);
                volumeBlock.addClass(soundON).removeClass(soundOFF);
            });
            volumeON.on('click', function() {
                player.volume = volume;
                if (player.volume === 0) {
                    player.volume = volume;
                }
                else {
                    volume = player.volume;
                    player.volume = 0;
                }
                volumeBar.progressbar('value', player.volume * 100);
                volumeBlock.addClass(soundOFF).removeClass(soundON);
            });
        }

        player.play();
        mediaBlock.removeClass(pauseClass).addClass(playClass);
    });

    function getTime(t) {
        let m = ~~(t / 60), s = ~~(t % 60);
        return (m < 10 ? m : m) + ':' + (s < 10 ? "0" + s : s);
    }
    function getProgressBarClickInfo(progressBar, e) {
        let offset = progressBar.offset(),
            x = e.pageX - offset.left,
            y = e.pageY - offset.top,
            max = progressBar.progressbar('option', 'max'),
            value = x * max / progressBar.width();

        return { x: x, y: y, max: max, value: value };
    }
    function mediaDurationHandler() {
        $('.js-media-controller').each(function(){
            let duration    = 0;
            const playerID  = $(this).find('audio').attr('id');
            const player    = document.getElementById(playerID);
            const timer     = $(this).find('.media-controller__timer');

            if( player.readyState > 0 ) {
                const minutes  = parseInt(player.duration / 60, 10);
                const seconds  = parseInt(player.duration % 60);
                      duration = minutes+":"+seconds;

                timer.text(duration);
            }
        });
    }
}

const input = () => {

    const parent        = '.js-input';
    const input         = $('.js-default-input');
    const clear         = $('.js-input-clear');
    const confirmation  = '.js-code-confirmation';
    const emptyClass    = 'input--not-empty';
    const errorClass    = 'input--error';
    const successClass  = 'input--success';
    let buttonDisabled  = true;

    input.on('keyup keydown', function(){
        const thisParent = $(this).parents(parent);

        if ( $(this).val() != '' ) {
            thisParent.addClass(emptyClass);
            buttonDisabled = false;

        } else {
            thisParent.removeClass(emptyClass);
            buttonDisabled = true;
        }

        if (typeof $(this).attr('data-button-confirm') !== 'undefined') {
            const id      = $(this).attr('data-button-confirm');
            const confirm = $(this).parents(confirmation);

            if (!buttonDisabled) {
                confirm.find(id).attr('disabled', false);

            } else {
                confirm.find(id).attr('disabled', true);
            }
        }
    });
    clear.on('click', function(){
        const thisParent = $(this).parents(parent);
        const thisInput  = thisParent.find('.js-default-input');

        if ( thisInput.val() != '' ) {
            thisInput.val('').trigger('keydown');
            thisParent.removeClass(emptyClass + " " + errorClass + " " + successClass);
        }
    });

}
const inputFile = () => {

    const parent    = '.js-input-file';
    const body      = '.js-input-file__body';
    const input     = '.js-input-file__file';
    const button    = '.js-input-file-button';
    const uploaded  = 'js-uploaded-file';

    $(document).on('click', button, function(){
        const inputFile  = $(this).parents(parent).find(input);

        inputFile.trigger('click');
    });

    $(input).on('change', function(){
        const thisParent = $(this).parents(parent);
        const thisBody   = thisParent.find(body);

        let uploadedFileName = this.files[0].name;

        if ( $(this).val ) {
            thisBody.hide();
            thisParent.append(uploadedFile(uploadedFileName, uploaded));
        }
    });

    $(document).on('click', '.js-uploaded-file', function(){
        const thisParent = $(this).parents(parent);
        const thisBody   = thisParent.find(body);
        const inputFile  = thisParent.find(input);

        thisBody.show();
        inputFile.val('');
        $(this).remove();
    });
}

const uploadedFile = (name, className) => {

    return '<button class="input-file__uploaded '+ className +'" type="button" title="Удалить файл">' +
        '<span class="input-file__uploaded-value js-uploaded-file-text">'+ name +'</span>' +
        '<span class="input-file__uploaded-icon">' +
            '<svg class="i">' +
                '<use xlink:href="#cross"></use>' +
            '</svg>' +
        '</span>' +
    '</button>';

}
const vacancyAppFormValidator = (id) => {
    if ( id.length ) {
        $.validator.setDefaults({
            debug: true,
            success: 'valid'
        });
        $.validator.addMethod("validate_email", function(value, element) {
            if (/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/.test(value)) {
                return true;
            } else {
                return false;
            }
        });
        $.validator.addMethod("validate_phone", function (value, element) {
            if ( window.isValidPhone ) {
                return true;
            }
            return value.replace(/\D+/g, '').length > 10;
        });

        id.validate({
            errorClass: "input--error",
            validClass: "input--success",
            rules : {
                candidateName   :'required',
                candidatePhone  : {
                    required        : true,
                    validate_phone  : true
                },
                formPhone  : {
                    required        : true,
                    validate_phone  : true
                },
                candidateEmail  : {
                    required       : true,
                    email          : true,
                    validate_email : true
                }
            },
            highlight: function(element, errorClass, validClass) {
                $(element).parents('.js-input').addClass(errorClass).removeClass(validClass);
            },
            unhighlight: function(element, errorClass, validClass) {
                $(element).parents('.js-input').removeClass(errorClass).addClass(validClass);
            },
            onfocusout: function(element) {
                if (!this.checkable(element) && (element.name in this.submitted || !this.optional(element))) {
                    this.element(element);
                }
            },
            submitHandler: function() {}
        });
    }
}
const callbackFormValidator = (id) => {
    if ( id.length ) {
        $.validator.setDefaults({
            debug: true,
            success: 'valid'
        });
        $.validator.addMethod("validate_email", function(value, element) {
            if (/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/.test(value)) {
                return true;
            } else {
                return false;
            }
        });
        $.validator.addMethod("minlenght_phone", function (value, element) {
            return value.replace(/\D+/g, '').length > 10;
        });
        $.validator.addMethod("required_phone", function (value, element) {
            return value.replace(/\D+/g, '').length > 1;
        });

        id.validate({
            errorClass: "input--error",
            validClass: "input--success",
            rules : {
                callbackFormTel: {
                    required: true,
                    validate_phone: true
                }
            },
            highlight: function(element, errorClass, validClass) {
                $(element).parents('.js-input').addClass(errorClass).removeClass(validClass);
            },
            unhighlight: function(element, errorClass, validClass) {
                $(element).parents('.js-input').removeClass(errorClass).addClass(validClass);
            },
            onfocusout: function (element) {
                if (!this.checkable(element) && (element.name in this.submitted || !this.optional(element)))
                {
                    var currentObj = this;
                    var currentElement = element;
                    var delay = function () { currentObj.element(currentElement); };
                    setTimeout(delay, 0);
                }
            },
            submitHandler: function() {}
        });
    }
}
const customSelect = () => {

    const select            = '.js-custom-select-value';
    const selectElement     = '.js-office-element';
    const selectElementVal  = '.js-office-element-value';
    const activeClass       = 'custom-select--opened';
    const selectedClass     = 'office-element--selected';

    $(select).on('click', function(){
        const parent = $(this).parents('.js-custom-select');
        if ( !parent.hasClass(activeClass) ) {
            parent.addClass(activeClass);
        }
        else {
            parent.removeClass(activeClass);
        }
    });

    $(selectElement).on('click', function(){
        const parent = $(this).parents('.js-custom-select');
        const val    = $(this).find(selectElementVal).text();

        $(selectElement).removeClass(selectedClass);

        if ( !$(this).hasClass(selectedClass) ) {
            $(this).addClass(selectedClass);
            parent.find(select).val(val);
            parent.removeClass(activeClass);
        }
    });


    $(document).on('mouseup touchend', function(e){
        if ( !$('.js-custom-select').is(e.target) && $('.js-custom-select').has(e.target).length === 0 ) {
            $('.js-custom-select').removeClass(activeClass);
        }
    });

}
const defaultCarousel = () => {

    const carousel  = $('.js-default-carousel');
    const thumbs    = $('.js-default-thumbs-carousel');

    if ( carousel.length && thumbs.length ) {
        carousel.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow       : '<button type="button" class="slick-prev"><svg class="i"><use xlink:href="#arrow-left"/></svg></button>',
            nextArrow       : '<button type="button" class="slick-next"><svg class="i"><use xlink:href="#arrow-right"/></svg></button>',
            dots: false,
            fade: true,
            asNavFor: thumbs,
            infinite: false,
            draggable: false,
            responsive: [
                {
                    breakpoint: 599,
                    settings: {
                        draggable: true
                    }
                }
            ]
        });

        thumbs.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            initialSlide: 2,
            asNavFor: carousel,
            arrows: false,
            dots: false,
            centerMode: true,
            centerPadding: 0,
            focusOnSelect: true,
            infinite: false
        });
    }
}
function accordion(container, collapsible) {

    var button  = container.find('.js-accordion-button'),
        accordionBody = container.find('.js-accordion-body');

    container.find('.js-accordion').each(function(){
        if (!$(this).hasClass('_expanded')) {
            $(this).find('.js-accordion-body').hide();
            $(this).find('.js-accordion-body').removeClass('_hide');
        }
    });

    button.on('click', function(){

        var accordion = $(this).parents('.js-accordion');

        if ( !accordion.hasClass('_expanded') ) {
            if (collapsible) {
                container.find('.js-accordion').removeClass('_expanded');
                accordionBody.stop().slideUp(300);
            }
            accordion.addClass('_expanded');
            accordion.find('.js-accordion-body').stop().slideDown(300);
        }
        else {
            accordion.removeClass('_expanded');
            accordion.find('.js-accordion-body').stop().slideUp(300);
        }
    });
}
const defaultTabs = (container, tab, button) => {

    const activeClass = '_active';

    $(button).on('click', function(e){
        e.preventDefault();

        const parent   = $(this).parents(container);
        const tabs     = parent.find(tab);
        const buttons  = parent.find(button);
        const id       = $(this).attr('data-tab-id');

        buttons.removeClass(activeClass);
        tabs.removeClass(activeClass).fadeOut(400);

        if ( !$(this).hasClass(activeClass) ) {
            //refresh slider if there is one in current tab
            if ( parent.find('.js-default-slider').length ) {
                $('.js-default-slider').slick('refresh');
            }

            $(this).addClass(activeClass);
            $('[data-default-tab="'+ id +'"]').addClass(activeClass).fadeIn(400);
        }
        else {
            return false;
        }
    });
}
const videoHandler = () => {

    const videoBlock  = '.js-video';
    const link        = $('.js-video-button');
    const activeClass = 'video--active';

    link.on('click', function(e){
        e.preventDefault();

        const parent = $(this).parents(videoBlock);
        const src    = parent.find('.js-video-src');
        const path   = $(this).attr('href');
        const id     = $(this).attr('data-video-id');
        const video  = $('#video-'+id).get(0);

        //play video if it's stopped and add class to its the parent
        if ( !parent.hasClass(activeClass) ) {

            if ( src.attr('src') === '' ) {
                src.attr('src', path);
                //after changing src we gotta .load() video
                video.load();
            }

            //stop all other videos and remove class from parents
            $(videoBlock).removeClass(activeClass);
            $.each($("video[id^='video']"), function(i, el){
                $(el).get(0).pause();
            });

            parent.addClass(activeClass);
            //then we play new video
            video.play();
        }
        else {
            parent.removeClass(activeClass);
            video.pause();
        }
    });
}
const defaultSlider = () => {

    const slider  = $('.js-default-slider');

    if ( slider.length ) {

        slider.on('init', function(event, slick){
            slider.removeClass(APP.hiddenClass);
        });

        slider.slick({
            slidesToShow    : 1,
            slidesToScroll  : 1,
            arrows          : true,
            prevArrow       : '<button type="button" class="slick-prev"><svg class="i"><use xlink:href="#arrow-left"/></svg></button>',
            nextArrow       : '<button type="button" class="slick-next"><svg class="i"><use xlink:href="#arrow-right"/></svg></button>',
            dots            : true,
            infinite        : false,
            responsive: [
                {
                    breakpoint: 559,
                    settings: {
                        dots: false
                    }
                }
            ]
        });
    }
}
const videoCarousel = () => {

    const carousel    = $('.js-video-carousel');
    //const poster      = carousel.find('.js-video-carousel-poster');
    const image       = carousel.find('.js-video-carousel-image');
    const video       = carousel.find('.js-video-carousel-video');
    const play        = carousel.find('.js-video-carousel-play');
    const title       = carousel.find('.js-video-carousel-title');
    const thumbs      = carousel.find('.js-video-carousel-thumb');
    const activeClass = 'video-carousel--playing';
    const thumbClass  = '_active';


    thumbs.on('click', function(e){
        e.preventDefault();

        const $this = $(this);
        thumbs.removeClass(thumbClass);

        if (!$this.hasClass(thumbClass)) {
            $this.addClass(thumbClass);
        }

        const thisPoster    = $this.attr('data-vc-poster');
        const thisPosterX2  = $this.attr('data-vc-poster-x2');
        const thisVideo     = $this.attr('data-vc-video');
        const thisTitle     = $this.attr('data-vc-title');

        // poster apply
        //poster.css('background-image', 'url('+ thisPoster +')');
        image.fadeOut(200).attr('src', thisPoster).attr('srcset', thisPosterX2).fadeIn(200);

        // title apply
        title.text(thisTitle);

        // video apply
        video[0].pause();

        if ( thisVideo ) {
            video.attr('src', thisVideo);
            //video.load();
        }
    });

    carousel.on('click','.js-video-carousel-play',function(){
        const parent     = $(this).parents('.js-video-carousel');
        const thisActive = parent.hasClass(activeClass);

        if (thisActive) {
            video[0].pause();
            parent.removeClass(activeClass);
        }
        else {
            parent.addClass(activeClass);
            video[0].play();
        }

        if ( video.length ){
            video[0].addEventListener('ended',function(){
                parent.removeClass(activeClass);
            });
        }
    });
    carousel.on('click','.js-video-carousel-stop',function(){
        const parent     = $(this).parents('.js-video-carousel');
        const thisActive = parent.hasClass(activeClass);

        if (thisActive) {
            video[0].pause();
            parent.removeClass(activeClass);
        }
    });

}
const languageCarousel = () => {

    const carousel = $('.js-language-carousel');

    if ( carousel.length ) {
        carousel.on('init', function(event, slick){
            carousel.removeClass(APP.hiddenClass);
        });

        carousel.slick({
            slidesToShow    : 2,
            variableWidth   : true,
            rows            : 0,
            infinite        : false,
            arrows          : true,
            dots            : false,
            prevArrow       : '<button type="button" class="slick-prev"><svg class="i"><use xlink:href="#stroke-arrow-left"/></svg></button>',
            nextArrow       : '<button type="button" class="slick-next"><svg class="i"><use xlink:href="#stroke-arrow-right"/></svg></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1
                    }
                },
                {
                    breakpoint: 599,
                    settings: {
                        variableWidth : false,
                        slidesToShow  : 1
                    }
                }
            ]
        });

    }

}
const searchBar = () => {

    const bar           = $('.js-search-bar');
    const input         = bar.find('.js-search-bar-input');
    const reset         = bar.find('.js-search-bar-reset');
    const activeClass   = '_not-empty';

    input.on('keyup keydown', function(){
        if ( $(this).val() != "" ) {
            bar.addClass(activeClass);
        }
        else {
            bar.removeClass(activeClass);
        }
    });
    reset.on('click', function(){
        if ( input.val() != "" ) {
            bar.removeClass(activeClass);
        }
    });

}
const chronologyCarousel = () => {

    const carousel   = $('.js-chronology-carousel');
    const tabButton  = $('.js-default-tabs-button');
    let initialSlide = window.currentPage || 0;

    if ( carousel.length ) {

        carousel.on('init', function(event, slick){
            carousel.removeClass(APP.hiddenClass);
        });
        carousel.on('afterChange', function(event, slick, currentSlide){});
        tabButton.on('click', function(){
            const id = $(this).attr('data-tab-id');
            //carousel.slick('slickGoTo', id);
        });
        carousel.slick({
            slidesToShow    : 8,
            variableWidth   : true,
            rows            : 0,
            infinite        : false,
            arrows          : false,
            dots            : false,
            touchThreshold  : 40,
            initialSlide    : initialSlide,
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 7
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 5
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 599,
                    settings: {
                        slidesToShow: 5
                    }
                },
                {
                    breakpoint: 479,
                    settings: {
                        slidesToShow: 5
                    }
                },
                {
                    breakpoint: 359,
                    settings: {
                        slidesToShow: 4
                    }
                }

            ]
        });

    }
}
const mobileAccordion = (width) => {

    const link        = $('.js-mobile-accordion-link');
    const body        = $('.js-mobile-accordion-body');
    const activeClass = '_active';

    link.on('click', function(e){
        e.preventDefault();
        const id        = $(this).attr('data-accordion-link');
        const accordion = $('[data-accordion-id="'+ id +'"]').find('[data-accordion-body="'+ id +'"]');

        const closestLinks  = $(this).closest('.js-mobile-accordion-body').find('.js-mobile-accordion-link');
        const closestBodies = $(this).closest('.js-mobile-accordion-body').find('.js-mobile-accordion-body');

        closestLinks.removeClass(activeClass);
        closestBodies.slideUp(350);

        if ( !$(this).hasClass(activeClass) && accordion.css('display') === 'none' ) {
            $(this).addClass(activeClass);
            accordion.stop().slideDown(350);
        } else {
            $(this).removeClass(activeClass);
            accordion.stop().slideUp(350);

            setTimeout(function(){
                accordion.attr('style', '');
            }, 400);
        }
    });


    $(window).on('resize', function(){
        if ( window.deviceWidth <= width ) {
            body.hide();
        } else {
            link.removeClass('_active');
            body.removeAttr('style');
        }
    });
}
const fileList = () => {

    const element       = '.js-file-list-element';
    const button        = '.js-file-list-button';
    const collapsed     = $(button).attr('data-file-list-collapsed');
    const expanded      = $(button).attr('data-file-list-expanded');
    const hiddenClass   = 'file-list__element--hidden';
    const activeClass   = '_active';

    $(document).on('click', button, function(){

        const parent   = $(this).parents('.js-file-list');
        const elements = parent.find(element);

        if ( !$(this).hasClass(activeClass) ) {
            $(this).addClass(activeClass).text(expanded);
            elements.removeClass(hiddenClass);
        }
        else {
            $(this).removeClass(activeClass).text(collapsed);
            elements.addClass(hiddenClass);
        }
    });

}
const photoGallery = (id) => {

    if ( id.length ) {
        id.magnificPopup({
            delegate            : 'a:not(.skip-gallery)',
            type                : 'image',
            closeMarkup         : '<button title="%title%" type="button" class="mfp-close popup-close"><svg class="i"><use xlink:href="#close-modal-white"/></svg></button>',
            closeOnContentClick : false,
            closeBtnInside      : true,
            mainClass           : 'mfp-with-zoom mfp-img-mobile',
            image               : {
                verticalFit     : true,
                titleSrc        : function(item) {
                    return item.el.attr('title');
                }
            },
            gallery             : {
                enabled         : true,
                arrowMarkup     : '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><svg class="i"><use xlink:href="#stroke-arrow-right"/></svg></button>',
            },
            zoom                : {
                enabled         : true,
                duration        : 300,
                opener          : function(element) {
                    return element.find('img');
                }
            }
        });
    }
}
const mobileFilterHandler = (width) => {

    const open          = $('.js-show-mobile-filter');
    const close         = $('.js-close-mobile-filter');
    const animatedClass = '_animated';
    const activeClass   = '_mobile-filter-shown';

    open.on('click', function(){
        if ( !APP.websiteWrapper.hasClass(activeClass) ) {
            APP.websiteWrapper.addClass(activeClass);
        }
    });
    close.on('click', function(){
        if ( APP.websiteWrapper.hasClass(activeClass) ) {
            APP.websiteWrapper.removeClass(activeClass);
        }
    });


    $(window).on('load resize', function(){
        if ( window.deviceWidth >= width ) {
            if ( APP.websiteWrapper.hasClass(activeClass) ) {
                APP.websiteWrapper.removeClass(activeClass);
            }
            if ( APP.websiteWrapper.hasClass(animatedClass) ) {
                APP.websiteWrapper.removeClass(animatedClass);
            }
        }
        else {
            if ( !APP.websiteWrapper.hasClass(animatedClass) ) {
                setTimeout(function(){
                    APP.websiteWrapper.addClass(animatedClass);
                }, 350);
            }
        }
    });
}
const tooltips = (width) => {

    const tooltip         = $('.js-tooltip');
    let arrowRight        = 'right';
    let arrowLeft         = 'left';
    let tooltipTrigger    = 'hover';

    $(window).on('load resize', function(){
        if ( window.deviceWidth < width ) {
            arrowRight      = 'bottom';
            arrowLeft       = 'bottom';
            tooltipTrigger  = 'click';
        }
    });

    if ( tooltip.length ) {
        tooltip.each(function(){

            if ( $(this).hasClass('_tooltip--right') ) {
                $(this).tooltipster({
                    trigger      : tooltipTrigger,
                    theme        : 'tooltipster-shadow',
                    side         : arrowRight,
                    contentAsHTML: true,
                    interactive  : true,
                    zIndex       : 95
                });
            }
            else if ( $(this).hasClass('_tooltip--left') ) {
                $(this).tooltipster({
                    trigger      : tooltipTrigger,
                    theme        : 'tooltipster-shadow',
                    side         : arrowLeft,
                    contentAsHTML: true,
                    interactive  : true,
                    zIndex       : 95
                });
            }
            else {
                $(this).tooltipster({
                    trigger      : tooltipTrigger,
                    theme        : 'tooltipster-shadow',
                    contentAsHTML: true,
                    interactive  : true,
                    zIndex       : 95
                });
            }

        });
    }

}
const tooltipsWithControl = (width) => {

    const tooltip         = $('.js-tooltip-with-control');
    let arrowRight        = 'right';
    let arrowLeft         = 'left';

    $(window).on('load resize', function(){
        if ( window.deviceWidth < width ) {
            arrowRight      = 'bottom';
            arrowLeft       = 'bottom';
        }
    });

    if ( tooltip.length ) {

        tooltip.on('click',function(){
            $(this).tooltipster('show');
        });

        $(document).on("mouseup touchend", function(e){
            if (!$('.tooltipster-base').is(e.target) && $('.tooltipster-base').has(e.target).length === 0) {
                tooltip.tooltipster('hide');
            }
        });

        tooltip.each(function(){
            if ( $(this).hasClass('_tooltip--right') ) {
                $(this).tooltipster({
                    trigger      : 'custom',
                    autoClose    : 'false',
                    theme        : 'tooltipster-default',
                    side         : arrowRight,
                    contentAsHTML: true,
                    interactive  : true,
                    zIndex       : 95,
                    functionReady: function(){
                        $('.js-tooltip-with-control-close').on('click',function(){
                            tooltip.tooltipster('hide');
                        });
                    }
                });
            }
            else if ( $(this).hasClass('_tooltip--left') ) {
                $(this).tooltipster({
                    trigger      : 'custom',
                    autoClose    : 'false',
                    theme        : 'tooltipster-default',
                    side         : arrowLeft,
                    contentAsHTML: true,
                    interactive  : true,
                    zIndex       : 95,
                    functionReady: function(){
                        $('.js-tooltip-with-control-close').on('click',function(){
                            tooltip.tooltipster('hide');
                        });
                    }
                });
            }
            else {
                $(this).tooltipster({
                    trigger      : 'custom',
                    autoClose    : 'false',
                    theme        : 'tooltipster-default',
                    contentAsHTML: true,
                    interactive  : true,
                    zIndex       : 95,
                    functionReady: function(){
                        $('.js-tooltip-with-control-close').on('click',function(){
                            tooltip.tooltipster('hide');
                        });
                    }
                });
            }
        });
    }

}
const fileUpload = () => {

    const parent        = '.js-file-upload';
    const button        = '.js-file-upload-button';
    const input         = '.js-file-upload-input';
    const uploadButton  = '.js-file-upload-button';
    const uploadSubmit  = '.js-file-upload-submit';
    const list          = '.js-file-upload-list';
    const uploaded      = 'js-file-upload-uploaded';
    const textInput     = '.js-file-upload__file-text';

    $(document).on('click', button, function(){
        const inputFile  = $(this).parents(parent).find(input);

        inputFile.trigger('click');
    });

    $(input).on('change', function(){
        const thisParent = $(this).parents(parent);
        const thisUpload = thisParent.find(uploadButton);
        const thisSubmit = thisParent.find(uploadSubmit);
        const thisList   = thisParent.find(list);
        const thisText   = thisParent.find(textInput);

        let uploadedFileName = this.files[0].name;

        if ( $(this).val ) {
            thisUpload.hide();
            thisSubmit.show();
            thisText.attr('disabled', true);
            thisList.append(uploadedFile(uploadedFileName, uploaded));
        }
    });

    $(textInput).on('change', function(){
        const thisParent = $(this).parents(parent);
        const thisUpload = thisParent.find(uploadButton);
        const thisSubmit = thisParent.find(uploadSubmit);
        const thisText   = thisParent.find(textInput);

        if ( $(this).val() ) {
            thisUpload.hide();
            thisSubmit.show();
        }
        else {
            thisUpload.removeAttr('style');
            thisSubmit.removeAttr('style');
            thisText.attr('disabled', false);
        }
    });

    $(document).on('click', '.js-file-upload-uploaded', function(){
        const thisParent = $(this).parents(parent);
        const inputFile  = thisParent.find(input);
        const thisUpload = thisParent.find(uploadButton);
        const thisSubmit = thisParent.find(uploadSubmit);
        const thisText   = thisParent.find(textInput);

        inputFile.val('');
        thisUpload.removeAttr('style');
        thisSubmit.removeAttr('style');
        thisText.attr('disabled', false);
        $(this).remove();
    });

}
const photoUploader = () => {

    const button = $('.js-photo-uploader-button');

    const body   = '.js-photo-uploader';
    const input  = '.js-photo-uploader-input';

    button.on('click', function(){
        const parent    = $(this).parents(body);
        const inputFile = parent.find(input);

        inputFile.trigger('click');
    });
    /*$(input).on('change', function(e){
        const parent        = $(this).parents(body);
        const picture       = parent.find(photo);
        const img           = parent.find(image);
        const uploadedImage = this.files[0].name;

        if ( $(this).val() ) {
            if ( img.length ) {
                img.css('background-image', 'url('+uploadedImage+')');
            }
            else {
                picture.append(uploadedPhoto(uploadedImage));
            }
        }
    });*/
}

function handleFileSelect(e) {
    if(window.FileReader) {
        const parent  = $(this).parents('.js-photo-uploader');
        const picture = parent.find('.js-photo-uploader-photo');
        const img     = parent.find('.js-photo-uploader-image');
        const file    = e.target.files[0];
        const reader  = new FileReader();

        if (file && file.type.match('image.*')) {
            reader.readAsDataURL(file);
        }
        reader.onloadend = function() {
            if ( img.length ) {
                img.css('background-image', 'url('+reader.result+')');
            }
            else {
                picture.append(uploadedPhoto(reader.result));
            }
        }
    }
}
const uploadedPhoto = (image) => {
    return '<div class="photo-uploader__image js-photo-uploader-image" style="background-image: url('+ image +')"></div>';
}

if ($('.js-photo-uploader-input').length) {
    document.querySelector('.js-photo-uploader-input').addEventListener('change', handleFileSelect, false);
}
const  headerSearch = () => {

    const search        = $('.js-header-search');
    const input         = $('.js-header-search-input');
    const button        = $('.js-header-search-button');
    const reset         = $('.js-header-search-reset');
    const activeClass   = '_active';
    const emptyClass    = '_not-empty';

    button.on('click', function(){
        if ( !search.hasClass(activeClass) ) {
            search.addClass(activeClass)
        }
        else {
            search.removeClass(activeClass)
        }
    });
    input.on('keyup keydown', function(){
        if ( $(this).val() != "" ) {
            search.addClass(emptyClass);
        }
        else {
            search.removeClass(emptyClass);
        }
    });
    reset.on('click', function(){
        search.removeClass(emptyClass);
    });
}
const popupSearch = () => {

    const search        = $('.js-popup-search');
    const input         = search.find('.js-popup-search-input');
    const emptyClass    = '_not-empty';

    input.on('keyup keydown', function(){
        if ( $(this).val() != "" ) {
            search.addClass(emptyClass);
        }
        else {
            search.removeClass(emptyClass);
        }
    });

}
const scrollTopHandler = () => {
    const body        = $('.js-scroll-top');
    const offset      = 200;
    const activeClass = 'scroll-top--visible';

    APP.websiteWrapper.on('scroll', function(){
        if ( APP.websiteWrapper.scrollTop() >= offset ) {
            body.addClass(activeClass);
        }
        else {
            body.removeClass(activeClass);
        }
    });


}
const scrollTop = () => {
    const link  = $('.js-scroll-top-link');

    link.on('click', function(){});
}
const inputWidthHandler = () => {

    const parent = '.js-input-auto-width-block';
    const hidden = '.js-hidden-block';
    const input  = $('.js-input-auto-width');

    input.on('input', function(){
        const val   = $(this).val();
        const block = $(this).parents(parent).find(hidden);

        block.text(val);
        $(this).css('min-width', block.width());
    });
}
const sortableList = () => {

    const list         = $('.js-sortable-list');
    const listMultiple = $('.js-sortable-multiple');
    const images       = $('.js-sortable-images');

    //ставим фиксированную высоту, чтобы избежать скачков
    //set fixed height to avoid "jumping"
    $(window).on('load resize', function(){
        const height    = list.outerHeight() + 'px';
        const body      = $('.js-sortable-list-element-body');
        let bodyWidth   = 0;

        list.css("height", height);

        //set equal width according to the maximal width of the element
        body.each(function(){
            const width  = $(this).outerWidth();
            if( bodyWidth < width) {
                bodyWidth = width;
            }
            $(this).css('width', bodyWidth);
        });
    });

    list
      .sortable({
          axis: "y",
          cursor: "move",
          update: function(e,ui){
              $('.js-sortable-list .js-sortable-list-element-body').each(function(i){
                  const text = $(this).text();
                  $('.js-fake-answer').eq(i).find('.js-sortable-list-element-body').text(text);
              });
          }
      })
      .disableSelection();

    listMultiple
      .sortable({
        cursor: "move",
        connectWith: ".js-draggable-multiple"
      })
      .disableSelection();

    images
      .sortable({
        tolerance : "pointer",
        cursor: "move"
      })
      .disableSelection();

    APP.websiteWrapper.on('scroll', function(){
        list.sortable( "refreshPositions" );
    });
}

const droppable = () => {

    const droppableElement   = $('.js-droppable-element');
    const droppableContainer = $('.js-droppable-container');

    droppableElement.draggable({
        helper : 'clone',
        revert : 'invalid'
    });

    droppableContainer.droppable({
        accept : '.js-droppable-element',
        activeClass: 'droppable__container--hover',
        hoverClass: 'droppable__container--active',
        drop: function( event, ui ) {
            const element = $(ui.draggable).clone();
            $(this).html(element);
        }
    });

}
const showMore = () => {

    const wrapper      = $('.js-show-more');
    const element      = $('.js-show-more-element');
    const button       = '.js-show-more-button';
    const hiddenClass  = 'show-more__hidden';

    $(document).on('click', button, function(){
        const parent   = $(this).parents(wrapper);
        const elements = parent.find(element);

        $(this).hide();
        elements.removeClass(hiddenClass);
    });

}
const kindaCheckbox = () => {

    const checkbox    = '.js-kinda-checkbox';
    const activeClass = '_active';

    $(document).on('click', checkbox, function(e){
        e.preventDefault();
        $(this).toggleClass(activeClass);
    });

}
const fileTable = () => {

    const table        = '.js-file-table';
    const body         = '.js-file-table-body';
    const checkbox     = '.js-kinda-checkbox';
    const download     = '.js-file-table-download-button';
    const row          = '.js-file-table-row';
    const allCheckbox  = '.js-file-table-all-checkbox';

    const activeClass  = '_active';
    const hiddenButton = 'button--hidden';

    $(document).on('click', allCheckbox, function(){

        const parent          = $(this).parents(table).find(body);
        const box             = parent.find(checkbox);
        const downloadButton  = $(this).parents(table).find(download);

        if ($(this).hasClass(activeClass)) {
            box.addClass(activeClass);
            box.parents(row).addClass(activeClass);
            downloadButton.removeClass(hiddenButton);
        }
        else {
            box.removeClass(activeClass);
            box.parents(row).removeClass(activeClass);
            downloadButton.addClass(hiddenButton);
        }
    });

    $(document).on('click', checkbox, function(){
        const parent           = $(this).parents(table);
        const parentBody       = parent.find(body);
        const downloadButton   = parent.find(download);
        const allCheckboxes    = parentBody.find(checkbox).length;
        const checkboxesActive = parentBody.find($('.js-kinda-checkbox._active')).length;

        //show download button
        if ( parent.find(checkbox).hasClass(activeClass) ) {
            downloadButton.removeClass(hiddenButton);
        }
        else {
            downloadButton.addClass(hiddenButton);
        }

        if ($(this).hasClass(activeClass)) {
            $(this).parents(row).addClass(activeClass);
        }
        else {
            $(this).parents(row).removeClass(activeClass);
        }

        //check if all elements are checked
        if ( allCheckboxes === checkboxesActive ) {
            $(allCheckbox).addClass(activeClass);
        }
        else {
            $(allCheckbox).removeClass(activeClass);
        }
    });

}
const comparisonTable = (id) => {

    const table = $(id).find('.js-comparison-table');

    for( let i = 0;  $(id).find("[data-table-row="+i+"]").length; i++) {
        let maxHeight = 0;
        table.find("[data-table-row="+i+"]").each(function(){
            let height = $(this).outerHeight(true);
            if( maxHeight < height) {
                maxHeight = height;
            }
        });

        $(id).find("[data-table-row="+i+"]").css('height', maxHeight);
    }
}
const simpleSlider = () => {

    const slider = $('.js-simple-slider');
    const hiddenClass = 'simple-slider--hidden';

    if ( slider.length ) {

        slider.on('init', function(event, slick){
            slider.removeClass(hiddenClass);
        });

        slider.slick({
            slidesToShow    : 1,
            rows            : 0,
            infinite        : false,
            arrows          : true,
            dots            : true,
            prevArrow       : '<button type="button" class="slick-prev"><svg class="i"><use xlink:href="#stroke-arrow-left"/></svg></button>',
            nextArrow       : '<button type="button" class="slick-next"><svg class="i"><use xlink:href="#stroke-arrow-right"/></svg></button>',
            adaptiveHeight  : true,
            responsive: [
                {
                    breakpoint: 599,
                    settings: {
                        arrows : false
                    }
                }
            ]
        });

    }
}
const stickyNavigation = () => {

    const wrapper     = $('.js-sticky-navigation-wrapper');
    const nav         = $('.js-sticky-navigation');
    const stickyClass = 'sticky-navigation-wrapper--stuck';

    if ( wrapper.length ) {

        APP.websiteWrapper.addClass('website-wrapper--landing-page');

        APP.websiteWrapper.on('scroll', function(){
            const offset = wrapper.offset().top;

            if ( offset <= 0 ) {
                wrapper.addClass(stickyClass);
                nav.css('max-width', window.deviceWidth + 'px');
            }
            else {
                wrapper.removeClass(stickyClass);
                nav.removeAttr('style');
            }
        });
    }
}
const preventPageScroll = () => {

    const block = $('.js-scroll-prevent');

    block.on( 'mousewheel DOMMouseScroll', function (e) {

        const e0 = e.originalEvent;
        const delta = e0.wheelDelta || -e0.detail;

        this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
        e.preventDefault();
    });

}
//https://github.com/verlok/lazyload/#include-lazyload-in-your-project
const lazyImages = () => {
    const lazyLoadInstance = new LazyLoad({
        container         : document.getElementById('website-wrapper'),
        elements_selector : '.js-lazy-image'
    });
}
const togglePayments = () => {

    const button       = $('.js-agreements-element-button');
    const element      = '.js-agreements-element';
    const history      = '.js-agreements-element-list';
    const activeClass  = '_active';

    button.on('click', function(e){
        e.preventDefault();

        const parent = $(this).parents(element);
        const list   = parent.find(history);

        if ( !parent.hasClass(activeClass ) ) {
            parent.addClass(activeClass);
            list.stop().slideDown(300);
        }
        else {
            parent.removeClass(activeClass);
            list.stop().slideUp(300);
        }

    });

}
const countryCode = () => {

    const body        = '.js-country-code';
    const button      = '.js-country-code-button';
    const input       = '.js-country-code-input';
    const inputResult = '.js-country-code-result';
    const flags       = '.js-country-code-flag';
    const codeValue   = '.js-country-code-value';
    const activeClass = 'country-code--opened';

    const currentMask = $(body).attr('data-current-mask');

    const element       = '.js-country-code-element';
    const elementActive = 'country-code__element--active';

    if ( !$(body).length ) return false;

    $(document).on('click', button, function() {
        const parent = $(this).parents(body);

        if ( !parent.hasClass(activeClass) ) {
            openCode(parent,activeClass);
        }
        else {
            closeCode(parent,activeClass);
        }
    });
    $(document).on('click', element, function() {

        const parent = $(this).parents(body);
        const current = parent.attr('data-current-country');
        const currentMask = parent.attr('data-current-mask');
        const $input = parent.find(input);
        const $inputResult = parent.find(inputResult);
        const $flag  = parent.find(flags);
        const $code  = parent.find(codeValue);

        const flag   = $(this).attr('data-flag');
        const code   = $(this).attr('data-code');
        const mask   = $(this).attr('data-mask');

        if ( !$(this).hasClass(elementActive) ) {
            //for validation
            window.isValidPhone = false;

            parent
                .attr('data-current-country', flag)
                .attr('data-current-mask', mask);

            if ( parent.hasClass('input--error') ) {
                parent.removeClass('input--error')
            }
            if ( parent.hasClass('input--success') ) {
                parent.removeClass('input--success')
            }

            $(element).removeClass(elementActive);
            //remove all phones and codes from visible and hidden inputs
            $input.val('');
            $inputResult
                .attr('data-phone-result', '')
                .val('');

            $(this).addClass(elementActive);
            $flag.removeClass('flag-icon-'+current).addClass('flag-icon-'+flag);
            $code.text(`+${code}`);
            $input.mask(mask, {
                completed : function(){
                    window.isValidPhone = true;
                }
            });

            closeCode(parent,activeClass);
        }
    });
    //set data attr and value for hidden input to get the whole phone number
    $(input).on('keyup keydown', function(e){
        const parent = $(this).parents(body);
        const $code  = parent.find(codeValue).text();
        const value  = `${$code} ${$(this).val()}`;

        $(inputResult)
            .attr('data-phone-result', value)
            .val(value);

    });
    $(document).on('mouseup touchend', function(e){
        if (!$(body).is(e.target) && $(body).has(e.target).length === 0 ) {
            closeCode($(body),activeClass);
        }
    });

    //set default input mask
    $(input).mask(currentMask, {
        completed : function(){
            window.isValidPhone = true;
        }
    });

    const openCode = (element, cls) => {
        element.addClass(cls);
    }
    const closeCode = (element, cls) => {
        element.removeClass(cls);
    }
}
$(function() {
	console.log(APP.name);

    /*создает кастомные скроллбары в указанных контейнерах*/
    if ( $('.js-scrollable-block').length ) {
        window.scrollbars = new CustomScrollbar($(".js-scrollable-block"));
    }

    lazyImages();
    topNavigation();
    headerCollapse();
    popup(APP.popupTrigger);
    popup(APP.audioLink);
    mobileNavigation(APP.desktopXsWidth);
    contactsWidget();
    heroSlider(APP.tabletWidth);
    coursesCarousel();
    selectStyler();

    schoolsMap('js-schools-map', 55.752695, 37.398951, 'assets/schools-list.json');
    schoolsMap('js-company-map', 55.162813, 61.411995, 'assets/schools-list.json');
    animation();
    responsiveTabs($('#route-tabs'), 'default');
    routeMap('js-walking-route', 55.665835, 37.548670);
    routeMap('js-public-route', 55.665835, 37.548670);
    routeMap('js-car-route', 55.665835, 37.548670);
    freeClassesSlider();
    teamCarousel(APP.mobileWidth + 1);
    reviewsCarousel();
    reviewsElement();
    scroll2(APP.tabletXsWidth);
    blogCarousel();
    inputTel($('.js-input-tel'));
    defaultValidator();
    appFormValidator($('#app-form'));
    callbackFormValidator($('#callback-form'));
    mapView(APP.tabletXsWidth);
    videoPopup();
    mediaController();
    input();
    inputFile();
    vacancyAppFormValidator($('#vacancy-app-form'));
    customSelect();
    defaultCarousel();
    accordion($('.js-acc-collapsible'), true);
    accordion($('.js-acc-non-collapsible'), false);
    defaultTabs('.js-default-tabs', '.js-default-tabs-body', '.js-default-tabs-button');
    defaultTabs('.js-sublevel-tabs', '.js-sublevel-tabs-body', '.js-sublevel-tabs-button');
    videoHandler();
    defaultSlider();
    videoCarousel();
    languageCarousel();
    searchBar();
    headerSearch();
    popupSearch();
    chronologyCarousel();
    mobileAccordion(APP.tabletWidth);
    fileList();
    mobileFilterHandler(APP.mobileWidth);
    tooltips(APP.mobileWidth);
    tooltipsWithControl(APP.mobileWidth);
    fileUpload();
    photoUploader();
    scrollTopHandler();
    inputWidthHandler();
    showMore();
    kindaCheckbox();
    fileTable();
    simpleSlider();
    stickyNavigation();
    preventPageScroll();
    togglePayments();
    countryCode();

    //sortable list
    sortableList();
    //droppabled
    droppable();

    //galleries

    //popups
    photoGallery(APP.licenseesGallery);
    photoGallery(APP.awardsGallery);
    photoGallery(APP.certificatesGallery);
    photoGallery(APP.freeClassesGallery);
});

$(window).on('load', function(){

    if (APP.websiteWrapper.hasClass(APP.noLoadedClass)) {
        APP.websiteWrapper.removeClass(APP.noLoadedClass);
    }

});
$(window).on('load resize', function(){

    window.deviceWidth           = APP.workArea.width();
    window.headerBarToShowHeight = $('.js-header-bar-to-show-element').height() + $('.js-website-header').height();
    //headerWidth();
});